"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityHeader = void 0;

var _react = _interopRequireDefault(require("react"));

var _Label = require("../Label");

var _Flex = require("../Flex");

var _Avatar = require("../Avatar");

var _Text = require("../Text");

var _excluded = ["name", "href", "meta", "initials", "imageUrl", "image", "smallVariant", "FollowButton", "labels"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Component that is used as entity header that is paired with rich information about the entity.
 * @deprecated: Use EntityHeader fragment container patterns within Force instead
 */
var EntityHeader = function EntityHeader(_ref) {
  var name = _ref.name,
      href = _ref.href,
      meta = _ref.meta,
      initials = _ref.initials,
      imageUrl = _ref.imageUrl,
      image = _ref.image,
      smallVariant = _ref.smallVariant,
      FollowButton = _ref.FollowButton,
      labels = _ref.labels,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(_Flex.Flex, _extends({
    alignItems: "center",
    justifyContent: "space-between"
  }, rest), /*#__PURE__*/_react.default.createElement(_Flex.Flex, _extends({
    alignItems: "center"
  }, href ? {
    as: "a",
    href: href,
    style: {
      textDecoration: "none"
    }
  } : {}), (imageUrl || image || initials) && /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    mr: 1
  }, /*#__PURE__*/_react.default.createElement(_Avatar.Avatar, _extends({
    size: smallVariant ? "xxs" : "xs",
    src: imageUrl,
    initials: initials
  }, image))), /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    flexDirection: "column",
    mr: 1
  }, /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "sm-display"
  }, name), /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "sm-display"
  }, labels === null || labels === void 0 ? void 0 : labels.map(function (label, i) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: i
    }, /*#__PURE__*/_react.default.createElement(_Label.Label, label), " ");
  })), meta && /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "xs",
    color: "black60"
  }, meta))), FollowButton);
};

exports.EntityHeader = EntityHeader;
EntityHeader.displayName = "EntityHeader";
EntityHeader.displayName = "EntityHeader";
//# sourceMappingURL=EntityHeader.js.map